import Iconify from 'src/components/iconify';


export const navConfig = [
  {
    title: 'Home',
    icon: <Iconify icon="solar:home-2-bold-duotone" />,
    path: '/',
  },
  {
    title: 'Support',
    icon: <Iconify icon="solar:question-circle-bold-duotone" />,
    path: '/support',
  },
  // Pricing intentionally hidden while in Free Beta — re-enable when paid plans launch.
  // {
  //   title: 'Pricing',
  //   icon: <Iconify icon="solar:dollar-bold-duotone" />,
  //   path: '/pricing',
  // },
];
